import { Block } from "payload";
import KinervaContactIcon from "./icon.png";

export const DEFAULT_FORM_HTML = `
<script src="https://js-eu1.hsforms.net/forms/embed/147703054.js" defer></script>
<div class="hs-form-frame" data-region="eu1" data-form-id="75703026-1b75-4a0b-a26f-4600d7782d54" data-portal-id="147703054"></div>
`;

export const KINERVA_CONTACT_BLOCK: Block = {
  slug: "kinerva-contact",
  imageURL: KinervaContactIcon.src,
  imageAltText: "Kinerva Contact",
  fields: [
    {
      name: "title",
      label: "Title",
      type: "text",
      required: false,
      defaultValue: "Get In Touch",
    },
    {
      name: "embedCode",
      label: "Embed Code",
      type: "code",
      admin: {
        language: "html",
        description: "Paste your form embed code here",
      },
      required: false,
      defaultValue: DEFAULT_FORM_HTML,
    },
  ],
};
